import "core-js/modules/es.number.constructor.js";
import activityinfo from '../activityinfo.vue';
import activityproduct from '../activityProduct2';
// import specialoffer from './specialoffer.vue'
// import integraldoubling from './integraldoubling.vue'
import activityDyx from '../addactivity/activityDyx.vue';
export default {
  name: 'EditActivity',
  i18n: require('../i18n-activity'),
  components: {
    activityinfo: activityinfo,
    activityproduct: activityproduct,
    // specialoffer,
    // integraldoubling,
    activityDyx: activityDyx
  },
  data: function data() {
    return {
      activityId: 0,
      activityType: 0,
      type: 1,
      lookInfo: null
    };
  },
  activated: function activated() {
    // this.activityType=Number(this.$route.query.activityType)
    this.activityId = Number(this.$route.query.id);
    this.lookInfo = Number(this.$route.query.look);
  },
  created: function created() {
    // this.activityType=Number(this.$route.query.activityType)
    this.activityId = Number(this.$route.query.id);
    this.lookInfo = Number(this.$route.query.look);
  },
  methods: {
    callback: function callback(key) {
      this.type = Number(key);
    }
  }
};